import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Spin } from "antd";
import { SERVER_URL } from "../../utils/axios";

const ResellerDirectConnect = ({ platform }) => {
  const { referralCode } = useParams();

  useEffect(() => {
    if (referralCode) {
      if (platform === "xero") {
        window.location.href = `${SERVER_URL}/callback/reseller_invite_xero?code=${encodeURIComponent(referralCode)}`;
      } else if (platform === "qbo") {
        window.location.href = `${SERVER_URL}/callback/reseller_invite_qbo?code=${encodeURIComponent(referralCode)}`;
      }
    }
  }, [referralCode, platform]);

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
      <Spin size="large" />
      <p className="text-sm text-gray-500 font-medium">Redirecting to securely connect your account...</p>
    </div>
  );
};

export default ResellerDirectConnect;
